import { environment } from '../../../../environments/environment';
import * as i0 from "@angular/core";
const DISABLED_CONFIG = {
    enabled: false,
    domain: '',
    clientId: '',
    audience: ''
};
export class PortalBootstrapService {
    constructor() {
        // Auth0 settings are read per-portal from the Angular environment file (environment.auth0),
        // keyed by team code. They are public client identifiers, so they ship with the build.
        // loadForTeam() must be called with the active team before auth0Enabled is read (done by the
        // APP_INITIALIZER for deep-links and by TeamTemplateResolver for the start-at-root flow).
        this.auth0Config = DISABLED_CONFIG;
        this.initialized = false;
    }
    // Runs at APP_INITIALIZER — covers full-page loads where the team is already in the URL.
    initialize() {
        return this.loadForTeam(this.extractTeamCodeFromUrl());
    }
    // Applies the environment's Auth0 config for the given team code. Synchronous; returns a
    // resolved promise so the APP_INITIALIZER / resolver callers keep their existing contracts.
    loadForTeam(teamCode) {
        this.auth0Config = this.resolveConfigForTeam(teamCode);
        this.initialized = true;
        return Promise.resolve();
    }
    get auth0Enabled() {
        return this.auth0Config.enabled;
    }
    resolveConfigForTeam(teamCode) {
        if (!teamCode) {
            return DISABLED_CONFIG;
        }
        const portals = environment.auth0 || {};
        const env = portals[teamCode.toLowerCase()];
        if (!env) {
            // No entry for this portal: leave Auth0 disabled (legacy login).
            return DISABLED_CONFIG;
        }
        return {
            enabled: env.enabled === true || env.enabled === 'true',
            domain: env.domain || '',
            clientId: env.clientId || '',
            audience: env.audience || ''
        };
    }
    extractTeamCodeFromUrl() {
        const path = window.location.pathname.replace(/^\//, '');
        if (!path) {
            return null;
        }
        const segments = path.split('/');
        return segments[0] || null;
    }
}
PortalBootstrapService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PortalBootstrapService_Factory() { return new PortalBootstrapService(); }, token: PortalBootstrapService, providedIn: "root" });
export function portalBootstrapInitializer(bootstrap) {
    return () => bootstrap.initialize();
}
